import { axios, API } from './config';

export const eventBriefsAPI = {
  // Get all briefs
  getAll: () => axios.get(`${API}/event-briefs`),

  // Get briefs for a contract
  getForContract: (contractId) => axios.get(`${API}/event-briefs/contract/${contractId}`),

  // Get single brief
  get: (briefId) => axios.get(`${API}/event-briefs/${briefId}`),

  // Create brief
  create: (data) => axios.post(`${API}/event-briefs`, data),

  // Delete brief
  delete: (briefId) => axios.delete(`${API}/event-briefs/${briefId}`),
};

export default eventBriefsAPI;
